import { render, staticRenderFns } from "./AppendixHandover.vue?vue&type=template&id=4a694117&scoped=true"
import script from "./AppendixHandover.vue?vue&type=script&lang=js"
export * from "./AppendixHandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a694117",
  null
  
)

export default component.exports